import {localAxiosRequest} from "@/utils/axios";
const SYS_BASE_URL = '/sys';

/**
 * 本地登录
 */
const login = function (param){
    return localAxiosRequest({
        method: 'POST',
        url: `${SYS_BASE_URL}/login`,
        data: param
    });
};

/**
 * 退出登录
 */
const logout = function (){
    return localAxiosRequest({
        method: 'GET',
        url: `${SYS_BASE_URL}/logout`,
    });
};

/**
 * 获取详情页链接地址名称
 */
const getInstitution = function (){
    return localAxiosRequest({
        method: 'GET',
        url: `${SYS_BASE_URL}/institution`,
    });
};

export { login, logout, getInstitution };
